import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormHelperText,
  Popover,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { colors } from "../../../../theme/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BreakpointBox, NoData, SimpleTextBox } from "../../Atoms";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useDateTime } from "../../../../hooks/useDateTime";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { amber, blue, green, grey, red } from "@mui/material/colors";
import { CustomModal } from "../../Organisms";
import { useState } from "react";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { ProductComponent } from "./ProductComponent";
import { ProductComponentCancel } from "./ProductComponentCancel";
import { SimpleConfirmModal } from "../SimpleConfirmModal";
import {
  cancelOrderService,
  updateOrderService,
} from "../../../../services/ordersService";
import StepperAcordion from "./Stepper";
import { useNavigate } from "react-router-dom";
import { GenericInput } from "../GenericInput";
import { CustomDatePicker } from "../DatePicker";
import { StatusScreen } from "@mercadopago/sdk-react";

interface Props {
  orders: OrderData[];
  loadingLine: { index: number | null; loading: boolean };
  getPayInfo: (orderID: number, chargeID: string, index: number) => void;
  verifyAndCharge: (orderID: number, chargeID: string) => void;
  isAdmin?: Boolean;
  getOrders?: VoidFunction;
}

export function OrderAcordion({
  isAdmin = false,
  orders,
  loadingLine,
  getPayInfo,
  verifyAndCharge,
  getOrders,
}: Props) {
  const { formatedDate } = useDateTime();
  const { BRLmoney } = useBRLmoney();
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const nav = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [openModalReturnTRK, setOpenModalReturnTRK] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({} as OrderData);
  const [selectedOptions, setSelectedOptions] = useState({
    cancelType: "",
    itens: [],
    refundValue: 0,
  } as CancelPayload);
  const [valueToUpdateOrder, setValueToUpdateOrder] = useState({
    key: null,
    value: null,
    date: null,
  });
  const [cancelOrderLoading, setCancelOrderLoading] = useState(false);
  const [errortoCancel, setErrorToCancel] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmModalOptions, setConfirmModalOptions] = useState({
    text: "",
    open: false,
    value: "",
  });
  const [openSendModal, setOpenSendModal] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openPix, setOpenPix] = useState({ open: false, chargeID: "" });
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const cleanSelectedOrder = () => {
    setSelectedOrder({} as OrderData);
    setOpenModal(false);
    setOpenSendModal(false);
    setSelectedOptions({ cancelType: "", itens: [], refundValue: 0 });
    setConfirmModalOptions({ text: "", open: false, value: "" });
    setOpenPix({ open: false, chargeID: "" });
  };

  const renderbuttontopay = (
    order: OrderData,
    index: number,
    renderButton: boolean
  ) => {
    if (!renderButton) {
      return <></>;
    }
    const height = "42px";
    if (order.paymentStatus === "in_process") {
      return (
        <Button
          variant="contained"
          onClick={() => getPayInfo(order.id, order.chargeID, index)}
          sx={{ height }}
        >
          Verificar pagamento
        </Button>
      );
    }
    if (order.paymentStatus === "rejected" && !isAdmin) {
      return (
        <Button
          variant="contained"
          onClick={() => {
            verifyAndCharge(order.id, order.chargeID);
          }}
          sx={{ height }}
        >
          Pagar o pedido
        </Button>
      );
    }
  };

  const refundValue = (items: ItensToCancel[], isTotalWithRefund?: boolean) => {
    if (!items) return 0;
    if (
      !isTotalWithRefund &&
      ["partialWithoutRefund", "totalWithoutRefund"].includes(
        selectedOptions.cancelType
      )
    ) {
      return 0;
    }

    const commumPRD = items?.reduce((acc, next) => {
      return acc + next?.boughtPrice * next?.quantityToCancel;
    }, 0);

    return commumPRD;
  };

  const cancelOrder = async () => {
    if (selectedOptions.itens.some((item) => item.quantityToCancel <= 0)) {
      setErrorToCancel(true);
    } else {
      setErrorToCancel(false);
    }
    setCancelOrderLoading(true);
    try {
      await cancelOrderService(selectedOptions);
    } catch {
    } finally {
      getOrders();
      setCancelOrderLoading(false);
      cleanSelectedOrder();
      setConfirmModal(false);
    }
  };

  const updateQuantityToCancel = (item: ItensToCancel[]) => {
    const map = item.map((prd) => ({ ...prd, quantityToCancel: prd.quantity }));
    return map;
  };

  const convertString = (status) => {
    const st = {
      canceled: "Cancelado",
      "partial-canceled": "Cancelamento parcial",
      partialWithRefund: "Cancelado parcialmente",
      partialWithoutRefund: "Cancelado parcialmente",
      totalWithoutRefund: "Cancelado",
      totalWithRefund: "Cancelado",
      ordered: "Pedido criado",
      separeted: "Em separação",
      send: "Enviado",
      returnToStock: "Retornar ao estoque",
    };
    return st[status];
  };

  const updateOrder = async () => {
    setLoadingUpdate(true);
    try {
      switch (valueToUpdateOrder.key) {
        case "returningTRKCODE":
          await updateOrderService({
            orderID: selectedOrder?.id,
            orderStatus: "returnToStock",
            returnTrackingCode: valueToUpdateOrder.value,
          });
          break;
        case "orderStatus":
          await updateOrderService({
            orderID: selectedOrder?.id,
            orderStatus: valueToUpdateOrder.value,
          });
          break;
        case "sendPackage":
          await updateOrderService({
            orderID: selectedOrder?.id,
            orderStatus: "send",
            trackingCode: valueToUpdateOrder.value,
            sendDate: valueToUpdateOrder.date,
          });
          break;
        default:
          break;
      }
    } catch {
    } finally {
      setLoadingUpdate(false);
      await getOrders();
      cleanSelectedOrder();
    }
  };

  const payStatus = {
    in_progress: "Em processamento",
    pending: "Aguardando confirmação do pagamento",
    approved: "Aprovado",
    rejected: "Não aprovado",
  };

  return (
    <>
      {orders?.length > 0 ? (
        orders?.map((order, index) => (
          <Accordion
            sx={{
              width: "100%",
              background: colors.purple[700],
            }}
            key={index}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ fill: "#FFFFFF" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ border: "1px solid #FFFFFF" }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: [2, 4],
                }}
              >
                <SimpleTextBox title="N° pedido" description={order?.id} />
                <SimpleTextBox
                  title="Data da compra"
                  description={formatedDate(order?.createdAt)}
                />
                <SimpleTextBox
                  title="Total pago"
                  description={BRLmoney(
                    order?.ordersXproducts?.reduce((acc, next) => {
                      return acc + next?.boughtPrice * next?.quantity;
                    }, 0)
                  )}
                />

                <SimpleTextBox
                  title="Status"
                  description={convertString(order?.orderStatus)}
                />
                <SimpleTextBox
                  title="Método de pagamento"
                  description={
                    order?.paymentType === "ticket"
                      ? "Boleto"
                      : order?.paymentType
                  }
                />
                <Box display={"flex"} gap={2}>
                  {order?.paymentStatus !== "approved" &&
                    ![
                      "partialWithRefund",
                      "partialWithoutRefund",
                      "totalWithoutRefund",
                      "totalWithRefund",
                    ].includes(order?.orderStatus) && (
                      <Typography
                        color={"#FFFFFF"}
                        sx={{ background: red[300], borderRadius: 1, p: 1 }}
                      >
                        {payStatus[order?.paymentStatus]}
                      </Typography>
                    )}
                  {loadingLine.index === index && loadingLine.loading ? (
                    <CircularProgress color="warning" />
                  ) : (
                    renderbuttontopay(
                      order,
                      index,
                      order?.ordersXproducts?.reduce((acc, next) => {
                        return acc + next?.Products?.price * next?.quantity;
                      }, 0) > 0
                    )
                  )}
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ background: "#FFFFFF" }}>
              {order?.paymentStatus === "in_process" && (
                <Typography fontWeight={500}>
                  Opa!, parece que você tem uma pendência no pagamento, nosso
                  sistema verifica o pagamento automaticamente de tempos em
                  tempos, mas caso deseje verificar o status agora, clique em
                  "Verificar pagamento".
                </Typography>
              )}
              {order?.ordersXproducts?.some((prd) => prd.isCanceled) &&
                ["partialWithRefund", "totalWithRefund"].includes(
                  order?.orderStatus
                ) && (
                  <FormHelperText
                    sx={{
                      bgcolor: amber[100],
                      borderRadius: "12px",
                      p: 1,
                      textAlign: "center",
                    }}
                  >
                    <WarningAmberRoundedIcon sx={{ marginBottom: -0.8 }} />
                    Este pedido possui um ou mais produtos cancelados com
                    reembolso, a devolução de valores ocorre pela operadora do
                    cartão e geralmente leva de 1 a 2 faturas para acontecer.
                  </FormHelperText>
                )}
              <Box
                display={"flex"}
                flexWrap={isSmalldesktop ? "wrap" : "nowrap"}
                width={"100%"}
              >
                <ProductComponent
                  selectedOrdersXproducts={order?.ordersXproducts}
                  changeQuantityToCancel={() => {}}
                />
                <Box
                  sx={{
                    borderRadius: "15px",
                    mt: 1,
                    display: "flex",
                    flexDirection:
                      isSmalldesktop && !isMobile ? "row" : "column",
                    justifyContent: isSmalldesktop
                      ? "space-between"
                      : "flex-start",
                    gap: 2,
                    width: isSmalldesktop ? "100%" : "auto",
                  }}
                >
                  <Box>
                    <Box>
                      <Typography
                        fontSize={21}
                        fontWeight={700}
                        color={colors.purple[500]}
                        m="10px 0"
                      >
                        Endereço de entrega
                      </Typography>
                      <>
                        <Typography>
                          {order?.address?.address + ", "}
                          {order?.address?.adressNumber}
                        </Typography>
                        {order?.address?.addressComplement && (
                          <Typography>
                            Complemento: {order?.address?.addressComplement}
                          </Typography>
                        )}
                        <Typography>
                          Bairro {order?.address?.neighborhood}
                        </Typography>
                        <Typography>
                          {order?.address?.city + ", "}{" "}
                          {order?.address?.country}
                        </Typography>
                        <Typography>
                          CEP: {order?.address?.postalCode}
                        </Typography>
                        <Typography>{order?.address?.receiver}</Typography>
                      </>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        mt: 1,
                        mb: 1,
                      }}
                    >
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        color={colors.purple[500]}
                      >
                        Código de rastreio:
                      </Typography>
                      <Typography fontSize={15}>
                        {order?.trackingCode
                          ? order?.trackingCode
                          : "Aguardando envio"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    gap={1}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                      }}
                    >
                      <Typography
                        fontSize={21}
                        fontWeight={700}
                        color={colors.purple[500]}
                      >
                        Quantidade de itens:
                      </Typography>
                      <Typography fontSize={21}>
                        {order?.ordersXproducts?.reduce(
                          (acc, next) => acc + next?.quantity,
                          0
                        )}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        fontSize={25}
                        fontWeight={700}
                        color={colors.purple[500]}
                      >
                        Itens do pedido:
                      </Typography>

                      <Typography fontSize={21}>
                        {BRLmoney(
                          order?.ordersXproducts?.reduce(
                            (acc, next) =>
                              acc + next?.boughtPrice * next?.quantity,
                            0
                          )
                        )}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                      }}
                    >
                      <Typography
                        fontSize={25}
                        fontWeight={700}
                        color={colors.purple[500]}
                      >
                        Frete:
                      </Typography>
                      <Typography fontSize={21}>
                        {order?.freteType} - {`R$ ${Number(order?.fretePrice)}`}
                      </Typography>
                    </Box>

                    {order?.paymentType === "ticket" &&
                      order?.paymentStatus === "pending" &&
                      ![
                        "partialWithRefund",
                        "partialWithoutRefund",
                        "totalWithoutRefund",
                        "totalWithRefund",
                      ].includes(order?.orderStatus) && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            width: "100%",
                          }}
                        >
                          <a
                            href={order?.billetLink}
                            target="_blank"
                            rel="noreferrer"
                            style={{ width: "100%" }}
                          >
                            <Button variant="contained" fullWidth>
                              Baixar boleto
                            </Button>
                          </a>
                        </Box>
                      )}
                    {order?.paymentType === "bank_transfer" &&
                      order?.paymentStatus === "pending" &&
                      ![
                        "partialWithRefund",
                        "partialWithoutRefund",
                        "totalWithoutRefund",
                        "totalWithRefund",
                      ].includes(order?.orderStatus) && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            width: "100%",
                          }}
                        >
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={() =>
                              setOpenPix({
                                open: true,
                                chargeID: order?.chargeID,
                              })
                            }
                          >
                            Pagar com pix
                          </Button>
                        </Box>
                      )}

                    {isAdmin && (
                      <Typography color={grey[500]} mt={2}>
                        ID do pagamento:{" "}
                        <span style={{ color: "black" }}>
                          {order?.chargeID}
                        </span>
                      </Typography>
                    )}
                    {order?.ordersXproducts?.some((prd) => prd.isCanceled) &&
                      [
                        "partialWithRefund",
                        "totalWithRefund",
                        "totalWithoutRefund",
                        "totalWithRefund",
                      ].includes(order?.orderStatus) && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 1,
                          }}
                        >
                          <Typography
                            fontSize={16}
                            fontWeight={700}
                            color={colors.purple[500]}
                          >
                            Total do reembolso:
                          </Typography>
                          <Typography fontSize={16}>
                            {BRLmoney(
                              order?.ordersXproducts?.reduce((acc, next) => {
                                if (
                                  next?.isCanceled &&
                                  next?.canceledWithRefund
                                ) {
                                  return (
                                    acc + next?.boughtPrice * next?.quantity
                                  );
                                } else {
                                  return acc;
                                }
                              }, 0)
                            )}
                          </Typography>
                        </Box>
                      )}

                    {order?.ordersXproducts?.some((prd) => prd.isCanceled) &&
                      [
                        "partialWithRefund",
                        "totalWithRefund",
                        "totalWithoutRefund",
                        "totalWithRefund",
                      ].includes(order?.orderStatus) && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 1,
                          }}
                        >
                          <Typography
                            fontSize={16}
                            fontWeight={700}
                            color={colors.purple[500]}
                          >
                            Total de itens cancelados:
                          </Typography>
                          <Typography fontSize={16}>
                            {order?.ordersXproducts?.reduce((acc, next) => {
                              if (next?.isCanceled) {
                                return acc + next?.quantity;
                              } else {
                                return acc;
                              }
                            }, 0)}
                          </Typography>
                        </Box>
                      )}
                    <Divider
                      sx={{
                        border: `1px solid ${colors.purple[500]}`,
                        width: "300px",
                        mt: 3,
                        mb: 3,
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              {order?.paymentType === "ticket" &&
                order?.paymentStatus === "pending" &&
                ![
                  "partialWithRefund",
                  "partialWithoutRefund",
                  "totalWithoutRefund",
                  "totalWithRefund",
                ].includes(order?.orderStatus) && (
                  <Typography mt={2}>
                    Por favor, efetue o pagamento do boleto dentro do prazo para
                    evitar que o pedido seja cancelado, caso já tenha pago, é só
                    aguardar a confirmação pela instituição bancaria que pode
                    acontecer nos próximos 3 dias úteis.
                  </Typography>
                )}
              <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  m="10px 0"
                  p={2}
                  borderRadius={5}
                  onClick={() => nav("/user/messages")}
                  sx={{
                    background: colors.purpleAlpha[300],
                    color: colors.purple[500],
                    cursor: "pointer",
                  }}
                >
                  <Typography fontWeight={500}>
                    Tem algum problema com o pedido?
                  </Typography>
                  <Typography fontWeight={500}>
                    Clique aqui e fale conosco!
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <StepperAcordion
                status={order?.orderStatus}
                returningTrackingCode={order?.returnTrackingCode}
              />
              {isAdmin && order?.users && (
                <Box
                  display={"flex"}
                  flexWrap={"wrap"}
                  gap={2}
                  width={"100%"}
                  justifyContent={"center"}
                  p={5}
                >
                  <Button
                    sx={{
                      background: blue[500],
                      color: "white",
                      "&:hover": { background: blue[200] },
                      width: 200,
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      setSelectedOrder(order);
                      setValueToUpdateOrder({
                        key: "orderStatus",
                        value: "ordered",
                        date: null,
                      });
                      setConfirmModalOptions({
                        open: true,
                        value: "ordered",
                        text: `Você está alterando o pedido número ${order?.id}. Confirmar alteração do status para *PEDIDO CRIADO*?`,
                      });
                    }}
                  >
                    Pedido criado
                  </Button>
                  <Button
                    sx={{
                      background: amber[500],
                      color: "white",
                      "&:hover": { background: amber[200] },
                      width: 200,
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      setSelectedOrder(order);
                      setValueToUpdateOrder({
                        key: "orderStatus",
                        value: "separeted",
                        date: null,
                      });
                      setConfirmModalOptions({
                        open: true,
                        value: "separeted",
                        text: `Você está alterando o pedido número ${order?.id}. Confirmar alteração do status para *SEPARAÇÃO CONCLUÍDA*?`,
                      });
                    }}
                  >
                    Separação concluída
                  </Button>

                  <Button
                    sx={{
                      background: green[500],
                      color: "white",
                      "&:hover": { background: green[200] },
                      width: 200,
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      setSelectedOrder(order);
                      setOpenSendModal(true);
                    }}
                  >
                    Pedido enviado
                  </Button>
                </Box>
              )}
              {isAdmin && order?.users && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    minWidth: "100%",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    overflowX: "auto",
                    gap: 1,
                    mt: 2,
                  }}
                >
                  <Typography color={grey[500]}>
                    Name:{" "}
                    <span style={{ color: "black" }}>{order?.users?.name}</span>
                  </Typography>
                  <Typography color={grey[500]}>
                    ID:{" "}
                    <span style={{ color: "black" }}>{order?.users?.id}</span>
                  </Typography>
                  <Typography color={grey[500]}>
                    Email:{" "}
                    <span style={{ color: "black" }}>
                      {order?.users?.email}
                    </span>
                  </Typography>
                  <Typography color={grey[500]}>
                    Phone:{" "}
                    <span style={{ color: "black" }}>
                      {order?.users?.phone}
                    </span>
                  </Typography>
                  <Button
                    sx={{
                      background: red[500],
                      color: "white",
                      "&:hover": { background: red[200] },
                    }}
                    onClick={() => {
                      setSelectedOrder(order);
                      setOpenModal(true);
                    }}
                  >
                    Cancel order
                  </Button>

                  <Button
                    sx={{
                      background: red[500],
                      color: "white",
                      "&:hover": { background: red[200] },
                    }}
                    onClick={() => {
                      setSelectedOrder(order);
                      setOpenModalReturnTRK(true);
                    }}
                  >
                    Preencher rastreio de devolução
                  </Button>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <NoData text="No orders found" />
      )}

      <CustomModal
        width={isSmalldesktop ? "90%" : "60%"}
        title="Cancel order"
        openModal={openModal}
        setOpenModal={cleanSelectedOrder}
        disableBackdropClick
      >
        <Box p={2}>
          <Typography>
            Aqui você pode cancelar o pedido com devolução do dinheiro ou
            escolher não devolver o dinheiro
          </Typography>

          <RadioGroup sx={{ display: "flex", flexDirection: "row" }}>
            <FormControlLabel
              value={"totalWithRefund"}
              control={<Radio />}
              label={"Total com reembolso"}
              onChange={() =>
                setSelectedOptions({
                  itens: updateQuantityToCancel(
                    selectedOrder.ordersXproducts.filter(
                      (item) => !item?.isCanceled
                    )
                  ),
                  cancelType: "totalWithRefund",
                  refundValue: refundValue(
                    updateQuantityToCancel(
                      selectedOrder.ordersXproducts.filter(
                        (item) => !item?.isCanceled
                      )
                    ),
                    true
                  ),
                })
              }
              checked={selectedOptions.cancelType === "totalWithRefund"}
            />

            <FormControlLabel
              value={"totalWithoutRefund"}
              control={<Radio />}
              label={"Total sem reembolso"}
              onChange={() =>
                setSelectedOptions((old) => ({
                  refundValue: 0,
                  itens: updateQuantityToCancel(
                    selectedOrder.ordersXproducts.filter(
                      (item) => !item?.isCanceled
                    )
                  ),
                  cancelType: "totalWithoutRefund",
                }))
              }
              checked={selectedOptions.cancelType === "totalWithoutRefund"}
            />

            <FormControlLabel
              value={"partialWithRefund"}
              control={<Radio />}
              label={"Parcial com reembolso"}
              onChange={() =>
                setSelectedOptions((old) => ({
                  refundValue: 0,
                  itens: [],
                  cancelType: "partialWithRefund",
                }))
              }
              checked={selectedOptions.cancelType === "partialWithRefund"}
            />

            <FormControlLabel
              value={"partialWithoutRefund"}
              control={<Radio />}
              label={"Parcial sem reembolso"}
              onChange={() =>
                setSelectedOptions((old) => ({
                  refundValue: 0,
                  itens: [],
                  cancelType: "partialWithoutRefund",
                }))
              }
              checked={selectedOptions.cancelType === "partialWithoutRefund"}
            />
          </RadioGroup>
        </Box>

        {["partialWithoutRefund", "partialWithRefund"].includes(
          selectedOptions.cancelType
        ) && (
          <Box display={"flex"} width={"100%"} justifyContent={"center"}>
            <Button
              aria-describedby={id}
              onClick={handleClick}
              variant="contained"
            >
              clique aqui e selecione os produtos
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <Box p={2}>
                {isSmalldesktop && (
                  <Button onClick={handleClose} variant="outlined">
                    Close
                  </Button>
                )}
                <ProductComponentCancel
                  onClick={(prd) =>
                    setSelectedOptions((old) => ({
                      ...old,
                      itens: updateQuantityToCancel(prd),
                      refundValue: refundValue(updateQuantityToCancel(prd)),
                    }))
                  }
                  ordersXproducts={selectedOrder.ordersXproducts}
                  selectedPRDS={selectedOptions.itens}
                />
              </Box>
            </Popover>
          </Box>
        )}
        <Box minHeight={300}>
          <ProductComponent
            selectedOrdersXproducts={selectedOptions?.itens}
            changeQuantityToCancel={(selectedPrds) =>
              setSelectedOptions((old) => ({
                ...old,
                itens: selectedPrds,
                refundValue: refundValue(selectedPrds),
              }))
            }
          />
          {selectedOptions?.itens?.length === 0 && (
            <Typography sx={{ textAlign: "center" }}>
              Nenhum produto selecionado
            </Typography>
          )}
        </Box>

        <Typography textAlign={"center"}>
          Total em R$ a reembolsar: {BRLmoney(selectedOptions.refundValue)}
        </Typography>
        {errortoCancel && (
          <FormHelperText error sx={{ textAlign: "center" }}>
            You can't cancel products with 0 parameter
          </FormHelperText>
        )}
        {/* {selectedOptions?.itens?.length > 0 && (
          <FormHelperText
            sx={{
              bgcolor: amber[100],
              borderRadius: "12px",
              p: 1,
              textAlign: "center",
            }}
          >
            <WarningAmberRoundedIcon sx={{ marginBottom: -0.8 }} />
            Please be assured that these products must be cancelled, upon
            completion of the process, the selected products will be returned to
            stock and removed from the customer's personal storage.
          </FormHelperText>
        )} */}

        <Box display={"flex"} justifyContent={"center"} gap={5} mt={1}>
          <Button
            sx={{ bgcolor: green[500], color: "white" }}
            onClick={() => setConfirmModal(true)}
            fullWidth
          >
            Confirmar
          </Button>
          <Button
            sx={{ bgcolor: red[500], color: "white" }}
            onClick={() => setConfirmModal(false)}
            fullWidth
          >
            Cancelar
          </Button>
        </Box>
      </CustomModal>

      <CustomModal
        width={isSmalldesktop ? "90%" : "60%"}
        title="Cancel order"
        openModal={openSendModal}
        setOpenModal={cleanSelectedOrder}
        disableBackdropClick
      >
        <Box p={2}>
          <Typography>{`Você está alterando o pedido número ${selectedOrder?.id}.`}</Typography>
          <Typography>
            Aqui você deve inserir a data que o pedido foi enviado, código de
            rastreio e ao confirmar esta ação, o pedido vai alterar o status
            para *ENVIADO*.
          </Typography>
        </Box>
        <BreakpointBox>
          <CustomDatePicker
            onChange={(val) =>
              setValueToUpdateOrder((old) => ({
                ...old,
                key: "sendPackage",
                date: val,
              }))
            }
            value={valueToUpdateOrder.date}
            placeholder="Data do envio"
          />

          <GenericInput
            inputName="sendPackage"
            onChange={(val) =>
              setValueToUpdateOrder((old) => ({
                ...old,
                key: "sendPackage",
                value: val,
              }))
            }
            placeholder="Código de rastreio de devolução"
            defaultValue={selectedOrder?.returnTrackingCode}
            hasIcon={false}
          />
        </BreakpointBox>

        <Box display={"flex"} justifyContent={"center"} gap={5} mt={1}>
          <Button
            sx={{ bgcolor: green[500], color: "white" }}
            onClick={updateOrder}
            fullWidth
          >
            Confirmar
          </Button>
          <Button
            sx={{ bgcolor: red[500], color: "white" }}
            onClick={() => setOpenSendModal(false)}
            fullWidth
          >
            Cancelar
          </Button>
        </Box>
      </CustomModal>

      <SimpleConfirmModal
        isLoading={cancelOrderLoading}
        cancelClick={() => {
          setConfirmModal(false);
        }}
        confirmClick={cancelOrder}
        open={confirmModal}
        text="Confirmar o cancelamento? Caso o pedido tenha valores a devolver, estas devoluções de valores podem demorar de 1 a 2 faturas para acontecer."
      />

      <SimpleConfirmModal
        isLoading={loadingUpdate}
        cancelClick={() => {
          setConfirmModalOptions({ text: "", open: false, value: "" });
        }}
        confirmClick={() => {
          updateOrder();
        }}
        open={confirmModalOptions.open}
        text={confirmModalOptions.text}
      />

      <CustomModal
        width={isSmalldesktop ? "90%" : "60%"}
        title="Retornar produto"
        openModal={openModalReturnTRK}
        setOpenModal={cleanSelectedOrder}
        disableBackdropClick
      >
        <Box p={2}>
          <Typography>
            Aqui você pode preencher o codigo de postagem de devolução que você
            gerou nos correios.
          </Typography>
        </Box>

        <FormHelperText
          sx={{
            bgcolor: amber[100],
            borderRadius: "12px",
            p: 1,
            textAlign: "center",
          }}
        >
          <WarningAmberRoundedIcon sx={{ marginBottom: -0.8 }} />
          Lembre-se que o cliente precisa desse codigo para ir aos correios
          levar o pacote.
        </FormHelperText>
        <GenericInput
          inputName="returningTrackingCode"
          onChange={(val) =>
            setValueToUpdateOrder({
              key: "returningTRKCODE",
              value: val,
              date: null,
            })
          }
          placeholder="Código de rastreio de devolução"
          defaultValue={selectedOrder?.returnTrackingCode}
          hasIcon={false}
        />

        <Box display={"flex"} justifyContent={"center"} gap={5} mt={1}>
          <Button
            sx={{ bgcolor: green[500], color: "white" }}
            onClick={() => {
              updateOrder();
              setOpenModalReturnTRK(false);
            }}
            fullWidth
          >
            Confirmar
          </Button>
          <Button
            sx={{ bgcolor: red[500], color: "white" }}
            onClick={() => setOpenModalReturnTRK(false)}
            fullWidth
          >
            Cancelar
          </Button>
        </Box>
      </CustomModal>

      <CustomModal
        width={isSmalldesktop ? "90%" : "60%"}
        title="Após o pagamento, atualize a tela ou aguarde"
        openModal={openPix.open}
        setOpenModal={cleanSelectedOrder}
        disableBackdropClick
      >
        <StatusScreen
          initialization={{ paymentId: openPix?.chargeID }}
          customization={{
            backUrls: {
              return: "https://coelhomagicostore.com.br/user/my-info",
            },
          }}
        />
      </CustomModal>
    </>
  );
}
